export default {
  graphql: {
    uri: '/graphql',
  },
  pollInterval: {
    newMessageByService: 1000 * 60 * 10,
    newLatestMessageFetch: 1000 * 60 * 5,
  },
};
